import PropTypes from 'prop-types';
import React from 'react';
import ActionText from '../core/ActionText';

class GetStarted extends React.Component {

    render() {

        const { text, action } = this.props;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '84px' }}>
                <div style={{ marginBottom: '36px' }}>
                    <ActionText>{text}</ActionText>
                </div>
                {
                    action && <div>
                        {action}
                    </div>
                }
            </div>
        );
    }
}

GetStarted.propTypes = {
    text: PropTypes.string.isRequired,
    action: PropTypes.object.isRequired
};

export default GetStarted;